import { useTranslation } from 'react-i18next';

import testingConstants from 'utils/testingConstants';

import ApiKeysStatePanel from './ApiKeysStatePanel';

const ApiKeysNoAccess = () => {
  const { t } = useTranslation();

  return (
    <ApiKeysStatePanel
      title={t('workspaces_settings.api_keys.no_access.title')}
      description={t('workspaces_settings.api_keys.no_access.body')}
      dataTestId={testingConstants.apiKeysNoAccess}
    />
  );
};

export default ApiKeysNoAccess;
